import { useCallback } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useApi() {
  const { getToken } = useAuth();
  return useCallback(async (method, url, data, opts = {}) => {
    const token = await getToken();
    const r = await axios({ method, url: `${API}${url}`, data, params: opts.params, signal: opts.signal, responseType: opts.responseType,
      headers: token ? { Authorization: `Bearer ${token}` } : {} });
    return r.data;
  }, [getToken]);
}

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return "Input tidak sah. Semak semula.";
  return "Ralat berlaku. Sila cuba lagi.";
};

export const isCancel = (e) => axios.isCancel(e) || e?.name === "CanceledError";

const sleep = (ms, signal) => new Promise((res, rej) => {
  const t = setTimeout(res, ms);
  signal?.addEventListener("abort", () => { clearTimeout(t); rej(new axios.CanceledError()); }, { once: true });
});

// Starts a background job and polls until done; aborting the signal cancels it server-side.
export async function runJob(api, path, body, signal, existingJobId) {
  const { job_id } = existingJobId ? { job_id: existingJobId } : await api("post", path, body, { signal });
  try {
    for (;;) {
      await sleep(2000, signal);
      const j = await api("get", `/hte/jobs/${job_id}`, null, { signal });
      if (j.status === "done") return j.result;
      if (j.status === "error") throw { response: { data: { detail: j.error }, status: j.code } };
      if (j.status === "cancelled") throw new axios.CanceledError();
    }
  } catch (e) {
    if (isCancel(e)) api("post", `/hte/jobs/${job_id}/cancel`).catch(() => {});
    throw e;
  }
}

export const TAFSIR_FOOTER = "Sumber data tafsir: set data terbuka Quran.com (melalui spa5k/tafsir_api). Teks ayat: fawazahmed0/quran-api. Terjemahan: Abdullah Muhammad Basmeih.";
